var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E2D347"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFD70F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.196c.852 0 1.544-.634 1.544-1.414 0-.78-.692-1.416-1.543-1.416-.852 0-1.544.635-1.544 1.416 0 .78.692 1.414 1.543 1.414zM9.931 12.302c.543.03 1.011-.291 1.05-.717l.56-6.285a.982.982 0 000-.17c-.06-.67-.799-1.174-1.649-1.127-.85.047-1.49.627-1.431 1.297l.559 6.285c.033.378.416.69.911.717z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOrange);
export default __webpack_public_path__ + "static/media/icon-check-orange.1e62189781e4eb12a03ab0c793b96e9d.svg";
export { ForwardRef as ReactComponent };